module.exports = __webpack_public_path__ + "media/images/sales/weddingday/thumb-pricing-01-5414a655b0c56e6852132d9b6b5b38f1.svg";